/**
 * Seta um cookie no navegador
 *
 * @param {string} cookiename
 * @param {string} cookievalue
 * @param {integer} expiredays
 * @param {string} path
 */
var setCookie = (
    cookiename,
    cookievalue,
    expiredays,
    expireminutes = null,
    path = null,
) => {
    var d = new Date()

    if (expireminutes) {
        d.setTime(d.getTime() + expireminutes * 60 * 1000)
    } else {
        d.setTime(d.getTime() + expiredays * 24 * 60 * 60 * 1000)
    }

    var expires = 'expires=' + d.toUTCString()

    var cookie = cookiename + '=' + cookievalue

    if (path) {
        cookie += ';path=' + path
    }

    document.cookie = cookie + ';' + expires
}

/**
 * Recupera o valor de um cookie pelo nome
 *
 * @param {string} cookiename
 */
var getCookie = cookiename => {
    var name = cookiename + '='
    var ca = document.cookie.split(';')

    for (var i = 0; i < ca.length; i++) {
        var c = ca[i]

        while (c.charAt(0) == ' ') {
            c = c.substring(1)
        }

        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length)
        }
    }

    return ''
}

module.exports = {
    setCookie: setCookie,
    getCookie: getCookie,
}
